<script>
    // Счётчик сбора кустов (квест «Дорога в Лос-Сантос») — панель справа,
    // в том же стиле, что ящик бизнесов (bizcrate.svelte).
    let harvest = null;
    window.lsHarvestHud = (json) => {
        try { harvest = json ? (typeof json === 'string' ? JSON.parse(json) : json) : null; }
        catch (e) { harvest = null; }
    };
</script>

{#if harvest}
<div class="lh">
    <div class="lh__box">
        <svg viewBox="0 0 48 48" class="lh__ico">
            <path d="M24 4c2 6 2 12 0 18-2-6-2-12 0-18z" fill="#4CAF50"/>
            <path d="M24 22c4-5 10-8 16-8-3 6-8 10-14 11 5 1 10 4 12 9-6-1-11-4-14-9v13h-2V25c-3 5-8 8-14 9 2-5 7-8 12-9-6-1-11-5-14-11 6 0 12 3 16 8z" fill="#66BB6A"/>
        </svg>
    </div>
    <div class="lh__name">Кусты марихуаны</div>
    <div class="lh__count">Собрано {harvest.c} <em>из {harvest.t}</em></div>
</div>
{/if}

<style>
    .lh {
        position: fixed; right: 2.4vh; top: 50%; transform: translateY(-50%);
        z-index: 45; width: 14vh; padding: 1.6vh 1.2vh 1.4vh;
        display: flex; flex-direction: column; align-items: center; gap: .5vh;
        background: rgba(20, 20, 22, .88); border-radius: 1.4vh;
        font-family: 'Manrope', 'Gilroy', sans-serif; color: #F2F0EB;
        pointer-events: none;
    }
    .lh__box { width: 6.5vh; height: 6vh; display: flex; align-items: center; justify-content: center; }
    .lh__ico { width: 100%; height: 100%; }
    .lh__name {
        font-size: 1.25vh; font-weight: 600; text-align: center; line-height: 1.2;
        max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
    .lh__count { font-size: 1.7vh; font-weight: 700; color: #E7AE3F; }
    .lh__count em { font-style: normal; font-size: 1.2vh; font-weight: 500; color: rgba(242, 240, 235, .5); }
</style>
